//removeIf(production)
import ClaroluzProgressIndicatorWorker from "./claroluz-progress-indicator-worker";
import ClaroluzModalDetail from "./modal-detail";
import ClaroluzModalLoading from "./modal-loading";
import ClaroluzModalMini from "./modal-loading-mini";
//endRemoveIf(production)

class ClaroluzModalInit {
    constructor() {
        new ClaroluzModalDetail();
        new ClaroluzProgressIndicatorWorker();
        new ClaroluzModalLoading();
        new ClaroluzModalMini();
    }
}

//removeIf(production)
export default ClaroluzModalInit;
//endRemoveIf(production)